import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ShareIconButton from './ShareIconButton';
import shareModal from '../../actions/share/shareModal';

const mapStateToProps = ({ estimateBuilder }) => ({
  sharedEmail:
  estimateBuilder.entities.estimates.byId[estimateBuilder.uiState.selectedEstimate].sharedEmail,
});

const mapDisptachToProps = dispatch => bindActionCreators({
  shareModal,
}, dispatch);

export default
connect(mapStateToProps, mapDisptachToProps)(ShareIconButton);
